// extracted by mini-css-extract-plugin
export var defaultWrapper = "_lh-3";
export var downloadButton = "_lh-4";
export var fileContainer = "_lh-9 _lh-7";
export var fileContainerBase = "_lh-7";
export var fileContainerFixedHeight = "_lh-8 _lh-7";
export var fileInfo = "_lh-5";
export var fileInfoWidthRestricted = "_lh-6";
export var fileType = "_lh-1";
export var fileTypeName = "_lh-2";
export var image = "_lh-0";
export var link = "_lh-b";
export var overflowEllipsis = "_lh-a";